import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateCustomerRequest, UpdateCustomerRequest, Customer, PagedCustomersRequest, PagedCustomersResponse } from '../models/customer.model';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  createCustomer(customerData: CreateCustomerRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/customers/create`, customerData);
  }

  getAllCustomers(): Observable<any> {
    return this.http.get(`${this.apiUrl}/customers/get-all`).pipe(
      map((response: any) => response)
    );
  }

  getCustomerById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/customers/${id}`);
  }

  updateCustomer(id: string, customerData: UpdateCustomerRequest): Observable<any> {
    return this.http.put(`${this.apiUrl}/customers/${id}`, customerData);
  }

  deleteCustomer(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/customers/${id}`);
  }

  getPagedCustomers(request: PagedCustomersRequest): Observable<PagedCustomersResponse> {
    return this.http.post<PagedCustomersResponse>(`${this.apiUrl}/customers/paged`, request);
  }
}
